import { useFactors } from "../state/FactorsContext";
import type { Scenario } from "../data/schema";
import { cn } from "../lib/cn";

/**
 * Buttons that snap EVERY slider to a shared worldview. The active one is
 * highlighted; if the user has hand-tuned anything, none are active ("custom").
 * `compact` is the slim version used in the pinned ticker.
 */
const OPTIONS: { id: Scenario; label: string; short: string; hint: string }[] = [
  {
    id: "pessimistic",
    label: "Hard Rare Earth",
    short: "Pessimistic",
    hint: "Pessimistic estimates — the number collapses to essentially zero",
  },
  {
    id: "consensus",
    label: "Mainstream",
    short: "Consensus",
    hint: "Best current consensus — we are effectively alone in the observable universe",
  },
  {
    id: "optimistic",
    label: "Optimistic / Copernican",
    short: "Optimistic",
    hint: "Generous estimates — millions of civilisations reappear",
  },
];

export default function ScenarioToggle({
  compact = false,
}: {
  compact?: boolean;
}) {
  const { applyScenario, activeScenario } = useFactors();

  return (
    <div
      role="group"
      aria-label="Set all sliders to a scenario"
      className={cn(
        "inline-flex rounded-full border border-white/10 bg-white/[0.04] p-1 backdrop-blur-sm",
        compact ? "" : "w-full max-w-lg",
      )}
    >
      {OPTIONS.map((opt) => {
        const active = activeScenario === opt.id;
        return (
          <button
            key={opt.id}
            type="button"
            onClick={() => applyScenario(opt.id)}
            aria-pressed={active}
            title={opt.hint}
            className={cn(
              "rounded-full font-medium leading-tight transition-colors",
              compact
                ? "px-3 py-1 text-xs"
                : "flex-1 px-3 py-2 text-xs sm:text-sm",
              active
                ? "bg-cyan/20 text-cyan shadow-glow"
                : "text-white/65 hover:text-white",
            )}
          >
            {compact ? opt.short : opt.label}
          </button>
        );
      })}
    </div>
  );
}
